webpackJsonp([0],{

/***/ "+JrN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1KP8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5mlR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "As/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('Tactics')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',{staticClass:"title"},[_vm._v(" Algorithmic Disobedience")]),_vm._v(" "),_c('h4',{staticClass:"subtitle"},[_vm._v(" A workshop by "),_c('a',{attrs:{"href":"http://www.tegabrain.com/"}},[_vm._v("Tega Brain")]),_vm._v(" & "),_c('a',{attrs:{"href":"http://www.suryamattu.com/"}},[_vm._v("Surya Mattu")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('h2',[_vm._v("\n          What is disobedience in a world shaped by algorithms?\n        ")]),_vm._v(" "),_c('p',[_vm._v("\nAlgorithmic disobedience calls for action in a world shaped by data and structured by algorithms. Algorithmic systems influence what news we see, who we date and how our neighbourhoods are policed. The accumulation of data has become paramount to the ways that power and resources are distributed and yet the logic of these systems are built on patterns drawn out of historic datasets, bringing the conditions of the past back to haunt the present.\n")]),_c('p',[_vm._v("\nIf individuals are legible only as aggregates of data, as products of pattern and probability, how can we push back? This workshop looks to recent work by artists and journalists for tactics of algorithmic disobedience.\n")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('h2',[_vm._v("\n        Goals of the workshop\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We invite the playful, the defiant and the dissatisfied to explore the growing role of these systems in our lives and script small acts of audit, obfuscation or opting out.\n        What are strategies that help us ask how we want these systems to be in our lives?\n        "),_c('br'),_c('br'),_vm._v("\n         Read the "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/0B8pZRjIECCvPVUIxcmQtQmw3TjQ/view?usp=sharing"}},[_vm._v("Algorithmic Disobedience Reader")]),_vm._v("  (5.6MB download)\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('h2',[_vm._v("\n    Upcoming dates:\n    ")]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_vm._v("26th and 28th October: "),_c('a',{attrs:{"href":"https://quantifiedselfonline.wordpress.com/events/"}},[_vm._v("The Quantified Self Davies Forum")]),_vm._v(", University of San Fransisco.")]),_vm._v(" "),_c('li',[_vm._v("11th November: "),_c('a',{attrs:{"href":"https://theglassroom.org/schedule/events/algorithmic-disobedience-surya-mattu/"}},[_vm._v("The Glass Room")]),_vm._v(", London.")]),_vm._v(" "),_c('li',[_vm._v("10th and 17th March: "),_c('a',{attrs:{"href":"http://fm.hunter.cuny.edu/art-activism-and-algorithms-aesthetic-interventions-in-machine-bias/"}},[_vm._v("Hunter College")]),_vm._v(", New York City.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C2sy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tactics_vue__ = __webpack_require__("ZKNI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d664206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tactics_vue__ = __webpack_require__("O55F");
function injectStyle (ssrContext) {
  __webpack_require__("1KP8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tactics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d664206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tactics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tactics__ = __webpack_require__("C2sy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: { Tactics: __WEBPACK_IMPORTED_MODULE_0__components_Tactics__["a" /* default */] },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "GeYL":
/***/ (function(module, exports) {

module.exports = {"tactics":[{"title":"Reveal/Expose","subtitle":"Expose the workings of an algorithmic system. Reveal how it works. Who does it advantage/disadvantage?","projects":[{"name":"Workers Leaving the Googleplex","artist":"Andrew Norman Wilson","url":"http://www.andrewnormanwilson.com/WorkersGoogleplex.html"},{"name":"Public Money, Institutional investment in Social Impact Bond","artist":"Cameron Rowland","url":"http://www.biennialfoundation.org/wp-content/uploads/2017/04/Rowland-_-Public-Money-1-1.pdf"},{"name":"White Collar Crime Predictor","artist":"Brian Clifton, Sam Lavigne and Francis Tseng","url":"https://whitecollar.thenewinquiry.com/"},{"name":"Nothing Personal","artist":"Marianna Bastashevski","url":"https://www.maribastashevski.com/nothing-personal"},{"name":"Net Art Rocks","artist":"Nick Briz","url":"http://netart.rocks/howto/the-wwweb-snorkeler"},{"name":"Prism","artist":"Julian Oliver and Danja Vasiliev","url":"https://criticalengineering.org/projects/prism-the-beacon-frame/"}]},{"title":"Audit","subtitle":"Audit an algorithm. What does it count? What can it see or not see?","projects":[{"name":"Machine Bias","artist":"Julia Angwin, Jeff Larson, Surya Mattu and Lauren Kirchner","url":"https://www.propublica.org/article/machine-bias-risk-assessments-in-criminal-sentencing"},{"name":"Invisible Infrastructure series","artist":"Share Lab","url":"https://labs.rs/en/category/invisible-infrastructures/"},{"name":"STD(ata): non-consensual data transmission on dating apps","artist":"Chupadados","url":"https://chupadados.codingrights.org/en/suruba-de-dados/"},{"name":"There's no such thing as a free watch","artist":"Jenny Odell","url":"http://www.jennyodell.com/free-watch.html"},{"name":"Your Smart Home Is Spying on You. Here’s How to Spy Back.","artist":"Surya Mattu","url":"https://fieldguide.gizmodo.com/your-smart-home-is-spying-on-you-here-s-how-to-spy-bac-1822939698"}]},{"title":"Obfuscate","subtitle":"Tactics for hiding in plain sight. Add noise to your signals. Bury your data. Make it harder to exploit and ultimately less valuable.","projects":[{"name":"Ad Nauseum","artist":"Daniel C. Howe, Mushon Zer Aviv and Helen Nissenbaum","url":"https://adnauseam.io/"},{"name":"Unfit Bits","artist":"Tega Brain and Surya Mattu","url":"https://unfitbits.com/"},{"name":"The Good Life, Email Enron Simulator","artist":"Tega Brain and Sam Lavigne","url":"https://enron.email/"},{"name":"Tor Browser","artist":"Many","url":"https://www.torproject.org/projects/torbrowser.html.en"},{"name":"Biononymous.me","artist":"Heather Dewey-Hagborg","url":"http://biononymous.me/"},{"name":"Hyperface","artist":"Hyphen Labs and Adam Harvey","url":"https://ahprojects.com/projects/hyperface/"}]},{"title":"Perform","subtitle":"Be the algorithm. Un-automate the system. Perform its bias.","projects":[{"name":"Follower","artist":"Lauren McCarthy","url":"http://lauren-mccarthy.com/follower"},{"name":"Get-Lauren","artist":"Lauren McCarthy","url":"https://get-lauren.com/"},{"name":"The Racist Door","artist":"Surya Mattu, Karl Ward and Jon Wasserman","url":"https://itp.nyu.edu/shows/spring2013/the-racist-door/"},{"name":"The Trial of Superdebthunterbot","artist":"Helen Knowles","url":"http://www.helenknowles.com/index.php/work/the_trial_of_superdebthunterbot"},{"name":"Smell Dating","artist":"Tega Brain and Sam Lavigne","url":"http://smell.dating"}]},{"title":"Critically/Poetically collect data","subtitle":"What is left out? What data is not collected? What datasets do not exist? ","projects":[{"name":"One Year Performance 1980 – 1981","artist":"Tehching Hsieh","url":"https://vimeo.com/16280427"},{"name":"On Missing Data Sets","artist":"Mimi Onuoha","url":"https://github.com/MimiOnuoha/missing-datasets"},{"name":"What Facebook Knows About You","artist":"Julia Angwin, Terry Parris Jr. and Surya Mattu","url":"https://www.propublica.org/article/breaking-the-black-box-what-facebook-knows-about-you"},{"name":"Dronestream","artist":"Josh Begley","url":"https://dronestre.am/"},{"name":"Material Speculations","artist":"Morehshin Allahyari","url":"http://www.morehshin.com/material-speculation-isis/"},{"name":"G02GL","artist":"Joana Moll","url":"http://www.janavirgin.com/CO2/CO2GLE_about.html"},{"name":"DEFOOOOOOOOOOOOOOOOOOOOOREST","artist":"Joana Moll","url":"http://www.janavirgin.com/CO2/DEFOOOOOOOOOOOOOOOOOOOOOREST_about.html"},{"name":"A SURVEY OF ICE PROPAGANDA VIDEOS","artist":"Sam Lavigne","url":"http://lav.io/ice/"}]},{"title":"Hide","subtitle":"Hide your data or yourself from surveillance, tracking or algorithmic observation.","projects":[{"name":"You Can Encrypt Your Face","artist":"Sam Lavigne, Aaron Miguel Cantu and Brian Clifton","url":"https://thenewinquiry.com/you-can-encrypt-your-face/"},{"name":"CV Dazzle","artist":"Adam Harvey","url":"https://cvdazzle.com/"},{"name":"The Orchid Project","artist":"Julian Oliver","url":"https://julianoliver.com/output/log_2015-06-16_22-45"},{"name":"Kardashian Crypt","artist":"Maddy Varner","url":"http://cargocollective.com/maddyv/KARDASHIAN-KRYPT"},{"name":"DECODELIA","artist":"Melanie Hoff","url":"https://melanie-hoff.com/DECODELIA/"},{"name":"How Not to be Seen: A Fucking Didactic Educational .MOV File","artist":"Hito Steyerl","url":"https://www.artforum.com/video/mode=large&id=51651"}]},{"title":"Redesign","subtitle":"Redesign, reimagine, rethink and build infrastructures. How might they embody an alternative politics?","projects":[{"name":"Harvest","artist":"Julian Oliver","url":"https://julianoliver.com/output/harvest"},{"name":"Occupy.Here","artist":"Dan Phiffer","url":"https://occupyhere.org/"},{"name":"3v/5v/12v","artist":"Aram Bartholl","url":"https://arambartholl.com/blog/3v-5v-12v/"},{"name":"Being Radiotropic","artist":"Tega Brain","url":"http://www.tegabrain.com/Being-Radiotropic"},{"name":"Othernet","artist":"Dhruv Mehrotra","url":"http://othernet.xyz/"},{"name":"Futureproof Meter","artist":"Natalie Jeremijenko","url":"http://www.margaritabenitez.com/readings/futureproofmeter.pdf"}]},{"title":"Opt Out","subtitle":"Encourage non-use, non-production, non-communication or non-partipation.","projects":[{"name":"How to do nothing","artist":"Jenny Odell","url":"https://medium.com/@the_jennitaur/how-to-do-nothing-57e100f59bbb"},{"name":"Lazy Coin","artist":"Brian Clifton, Sam Lavigne, Karl Ward, Jon Wasserman, and Surya Mattu","url":"http://lav.io/2014/05/lazycoin-officially-patented/"},{"name":"Log Jammer","artist":"Allison Burtch","url":"http://www.allisonburtch.net/log-jammer/"},{"name":"A Month Without a Fork","artist":"Darius Kazemi","url":"http://fork-free.tumblr.com/"}]}]}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b15854d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("P7nk");
function injectStyle (ssrContext) {
  __webpack_require__("5mlR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b15854d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "O55F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('h1',[_vm._v(" Tactics")]),_vm._v(" "),_vm._l((_vm.content.tactics),function(tactic){return _c('div',{staticClass:"tactic"},[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(tactic.title)+" ")]),_vm._v(" "),_c('h3',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(tactic.subtitle)+" ")]),_vm._v(" "),_vm._l((tactic.projects),function(project){return _c('div',{staticClass:"projects"},[_c('div',[_c('a',{attrs:{"href":project.url}},[_vm._v(" "+_vm._s(project.name))]),_vm._v(" - "),_c('span',[_vm._v(_vm._s(project.artist)+" ")])])])})],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P7nk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tactics__ = __webpack_require__("C2sy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__("lO7g");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/tactics',
    name: 'Tactics',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Tactics__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZKNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tactics_json__ = __webpack_require__("GeYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tactics_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tactics_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tactics',
  data: function data() {
    return {
      content: __WEBPACK_IMPORTED_MODULE_0__tactics_json___default.a
    };
  }
});

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_154e0624_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("As/D");
function injectStyle (ssrContext) {
  __webpack_require__("+JrN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_154e0624_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3c282023a9bd4619b9a6.js